import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { settingsAPI } from '../../lib/api';
import { SEO_CATEGORIES } from '../../lib/seoCategories';

const Footer = () => {
  const [settings, setSettings] = useState({
    contact_email: 'info@udsplans.co.za',
    contact_phone: '+27 (0) 11 234 5678',
    contact_address: '',
    about_text: 'UmPhakathi Design Studio offers professional predesigned building plans for your dream home.',
    terms_file_id: null,
    privacy_file_id: null,
    terms_conditions_file_id: null,
    refund_policy_file_id: null
  });

  useEffect(() => {
    settingsAPI.getSettings().then(r => setSettings(r.data)).catch(() => {});
  }, []);

  const backendUrl = process.env.REACT_APP_BACKEND_URL;

  return (
    <footer className="bg-primary text-white mt-auto" data-testid="main-footer">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="md:col-span-1">
            <h3 className="text-lg font-bold mb-4" style={{ fontFamily: 'Cabinet Grotesk, sans-serif' }}>UDS Plans</h3>
            <p className="text-sm text-gray-300 leading-relaxed">
              {settings.about_text}
            </p>
          </div>

          <div>
            <h4 className="text-sm font-bold mb-4 uppercase tracking-wider" style={{ fontFamily: 'JetBrains Mono, monospace' }}>Browse House Plans</h4>
            <ul className="space-y-2 text-sm max-h-80 overflow-y-auto pr-2" data-testid="footer-seo-links">
              {SEO_CATEGORIES.map(cat => (
                <li key={cat.slug}>
                  <Link to={`/${cat.slug}`} className="text-gray-300 hover:text-accent transition-colors">
                    {cat.heading}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold mb-4 uppercase tracking-wider" style={{ fontFamily: 'JetBrains Mono, monospace' }}>Quick Links</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/plans" className="text-gray-300 hover:text-accent transition-colors">Browse Plans</Link></li>
              <li><a href="https://quote.umphakathids.co.za" target="_blank" rel="noreferrer" className="text-gray-300 hover:text-accent transition-colors">Custom Design</a></li>
              <li><Link to="/orders" className="text-gray-300 hover:text-accent transition-colors">My Orders</Link></li>
              <li><Link to="/cart" className="text-gray-300 hover:text-accent transition-colors">Cart</Link></li>
              {settings.terms_file_id && (
                <li><a href={`${backendUrl}/api/files/${settings.terms_file_id}`} target="_blank" rel="noreferrer" className="text-gray-300 hover:text-accent transition-colors" data-testid="terms-link">Terms of Service</a></li>
              )}
              {settings.terms_conditions_file_id && (
                <li><a href={`${backendUrl}/api/files/${settings.terms_conditions_file_id}`} target="_blank" rel="noreferrer" className="text-gray-300 hover:text-accent transition-colors" data-testid="terms-conditions-link">Terms &amp; Conditions</a></li>
              )}
              {settings.privacy_file_id && (
                <li><a href={`${backendUrl}/api/files/${settings.privacy_file_id}`} target="_blank" rel="noreferrer" className="text-gray-300 hover:text-accent transition-colors" data-testid="privacy-link">Privacy Policy</a></li>
              )}
              {settings.refund_policy_file_id && (
                <li><a href={`${backendUrl}/api/files/${settings.refund_policy_file_id}`} target="_blank" rel="noreferrer" className="text-gray-300 hover:text-accent transition-colors" data-testid="refund-policy-link">Refund Policy</a></li>
              )}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold mb-4 uppercase tracking-wider" style={{ fontFamily: 'JetBrains Mono, monospace' }}>Contact</h4>
            <div className="text-sm text-gray-300 space-y-2">
              {settings.contact_email && <div>Email: <a href={`mailto:${settings.contact_email}`} className="hover:text-accent">{settings.contact_email}</a></div>}
              {settings.contact_phone && <div>Phone: {settings.contact_phone}</div>}
              <div>WhatsApp: <a href="https://wa.me/27620845006" target="_blank" rel="noreferrer" className="hover:text-accent">062 084 5006</a></div>
              {settings.contact_address && <div className="whitespace-pre-line">{settings.contact_address}</div>}
            </div>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-10 pt-6 text-center text-sm text-gray-400">
          <p>&copy; 2026 UmPhakathi Design Studio. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
